import React from 'react';

import { ForumPost } from '../../../utils/backend-api/forumPosts';
import { TIModal } from '../../BaseUI';
import ShareModalContent from './ShareModalContent';
import styles from './styles.module.scss';

export default function ShareModal({
  forumPost,
  isOpen,
  setIsOpen,
  onDownloadScreenshot,
}: {
  forumPost: ForumPost;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  onDownloadScreenshot: () => void;
}) {
  return (
    <>
      <TIModal
        isOpen={isOpen}
        disableScrollLock={false}
        onClose={() => setIsOpen(false)}
        parentClass={styles.shareModal}
      >
        <ShareModalContent forumPost={forumPost} onDownloadScreenshot={onDownloadScreenshot} />
      </TIModal>
    </>
  );
}
